import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';

const FundManagerName = styled<any, any>('h4')`
    ${propStyles};
`;

FundManagerName.defaultProps = {
    color: 'body',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'sm',
    textAlign: ['left', 'center'],
    marginY: 'sm',
};

const FundManagerExtendedItems = styled<any, any>('ul')`
    ${propStyles};
`;

FundManagerExtendedItems.defaultProps = {
    listStyle: 'none',
};

const FundManagerExtendedItem = styled<any, any>('li')`
    ${propStyles};
`;

FundManagerExtendedItem.defaultProps = {};

const FundManagerExtendedItemText = styled<any, any>('p')`
    ${propStyles};
`;

FundManagerExtendedItemText.defaultProps = {};

const FundManagerBiography = styled<any, any>('p')`
    ${propStyles};
`;

FundManagerBiography.defaultProps = {
    color: 'body',
    fontFamily: 'body',
    fontWeight: 'regular',
    fontSize: 'sm',
    marginY: 'sm',
};

const FundManagerLink = styled<any, any>('a')`
    ${propStyles};
`;

FundManagerLink.defaultProps = {
    display: 'block',
    color: 'link',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'xs',
    hover: {
        color: 'linkHover',
    },
};

interface FundManagerContentProps {
    theme?: any;
    fundManager: {
        name: string;
        biography: string;
        extended: Array<{
            label: string;
            value: string;
        }>;
        link: {
            label: string;
            value: string;
        };
    };
}

const FundManagerContent: React.SFC<FundManagerContentProps> = ({
    theme,
    fundManager,
}) => (
    <Fragment>
        <FundManagerName {...theme.FundManagerName}>
            {fundManager.name}
        </FundManagerName>
        {fundManager.extended && fundManager.extended.length > 0 && (
            <FundManagerExtendedItems {...theme.FundManagerExtendedItems}>
                {fundManager.extended.map((extended, extendedIndex) => (
                    <FundManagerExtendedItem
                        key={extendedIndex}
                        {...theme.FundManagerExtendedItem}
                    >
                        {extended.label && (
                            <FundManagerExtendedItemText
                                {...theme.FundManagerExtendedItemLabel}
                            >
                                <Translate>{extended.label}</Translate>
                            </FundManagerExtendedItemText>
                        )}
                        <FundManagerExtendedItemText
                            {...theme.FundManagerExtendedItemValue}
                        >
                            <Translate>{extended.value}</Translate>
                        </FundManagerExtendedItemText>
                    </FundManagerExtendedItem>
                ))}
            </FundManagerExtendedItems>
        )}
        {fundManager.biography && (
            <FundManagerBiography {...theme.FundManagerBiography}>
                {fundManager.biography}
            </FundManagerBiography>
        )}
        {fundManager.link && (
            <FundManagerLink
                href={fundManager.link.value}
                {...theme.FundManagerLink}
            >
                <Translate>{fundManager.link.label}</Translate>
            </FundManagerLink>
        )}
    </Fragment>
);

export default withTheme(observer(FundManagerContent));



// WEBPACK FOOTER //
// ./src/Components/FundManagerContent.tsx